import { inject, singleton } from "@launchtray/tsyringe-async";
import { IAnalyticProviderWrapper } from "../../../../analytics/IAnalyticProviderWrapper";
import { VirtualScreenEvent } from "../../../../analytics/events/VirtualScreenEvent";
import { Bindable } from "../../../../shared/bindable-data";
import { IApplePayApi } from "../../../purchases/IApplePayApi";
import { IApplicationModel } from "./IApplicationModel";
import { GameInfo, Stage } from "by/gamefactory/analytics/GameInfo";

@singleton()
export class ApplicationModel extends Bindable implements IApplicationModel {
    private readonly analyticsProvider: IAnalyticProviderWrapper;
    private readonly applePayApi: IApplePayApi;

    private appStartTime: number;
    private gameLoadHandled: boolean;

    public constructor(
        @inject("IApplePayApi") applePayApi: IApplePayApi,
        @inject("IAnalyticProviderWrapper") analyticsProvider: IAnalyticProviderWrapper,
        gameInfo: GameInfo
    ) {
        super();
        this.applePayApi = applePayApi;
        this.analyticsProvider = analyticsProvider;
        this.appStartTime = Date.now();
        this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Start home screen", 0));
        this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("New Cache Start home screen", 0));
        const haveEventName = "Home screen user has CC on Apple pay";
        const notHaveEventName = "Home screen DOESN'T have CC on Apple pay";
        if (gameInfo.stage !== Stage.LOCALHOST) {
            this.applePayApi.applePayAvailableWithActiveCardEvent(haveEventName, notHaveEventName);
        }
    }

    public async gameLoadedHandle(): Promise<void> {
        if (!this.gameLoadHandled) {
            this.gameLoadHandled = true;
            const loadTime = ((Date.now() - this.appStartTime) / 1000) % 60;
            const gaEventName = "Home screen loading";
            this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent(gaEventName, 0, parseFloat(loadTime.toFixed(1))));
        }
    }
}
